
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { Filter } from "@/types/components";
import { Sorting } from "@/types/Filters";

@Component
export default class TheModalSort extends Vue {
  @Prop() filters!: Filter;
  @Prop({ default: false }) visible: boolean;
  @Prop() value!: any;

  public options: Array<any> = new Sorting().options;

  public selected(event: any) {
    this.$emit("selected", event);
    this.closeModal();
  }

  public closeModal() {
    this.$emit("close-modal");
  }
}
